export default __webpack_public_path__ + "static/media/jackpotIcon.143b2afd.svg";